import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _53f92d82 = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _61c6f158 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _758bec8a = () => interopDefault(import('../pages/apple-iphone-17-zubehoer.vue' /* webpackChunkName: "pages/apple-iphone-17-zubehoer" */))
const _cf3ec93c = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _b4e96f62 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _22ac6ea8 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _122800ac = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _30e15d32 = () => interopDefault(import('../pages/magenta-black-days/index.vue' /* webpackChunkName: "pages/magenta-black-days/index" */))
const _36870dc6 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _09aa0960 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _150090c2 = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _7ab5935c = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _1998f2e8 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _fc9ed1f2 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _6f6483ec = () => interopDefault(import('../pages/sicherheit-und-einbruchschutz.vue' /* webpackChunkName: "pages/sicherheit-und-einbruchschutz" */))
const _c4dad58e = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _3c3a7f97 = () => interopDefault(import('../pages/smarte-gemuetlichkeit.vue' /* webpackChunkName: "pages/smarte-gemuetlichkeit" */))
const _be6c2390 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _bad84bf6 = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _440a85ea = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _71156da1 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _04a25d22 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _f35e29e4 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _649b839c = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _fb1d2e5a = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _d2bc3bb2 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _0a4c66da = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _45a4617c = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _8fa27fb2 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _af870bd0 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _3dbe239a = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _298f8cd6 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _b5377f84 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _27cea5f8 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _17bf9e32 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _52b163a6 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _f76a52a4 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _1dc1cbe8 = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _0dcccaf7 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _2f732385 = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _78ceb7cb = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _215a159b = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _3b57c77c = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _0c9e5648 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _53f92d82,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _61c6f158,
    name: "anker"
  }, {
    path: "/apple-iphone-17-zubehoer",
    component: _758bec8a,
    name: "apple-iphone-17-zubehoer"
  }, {
    path: "/google",
    component: _cf3ec93c,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _b4e96f62,
    name: "handyrechnung-aktion"
  }, {
    path: "/infos-zum-online-kauf",
    component: _22ac6ea8,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _122800ac,
    name: "kontakt"
  }, {
    path: "/magenta-black-days",
    component: _30e15d32,
    name: "magenta-black-days"
  }, {
    path: "/maintenance",
    component: _36870dc6,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _09aa0960,
    name: "merkliste"
  }, {
    path: "/newsletter",
    component: _150090c2,
    name: "newsletter"
  }, {
    path: "/panzerglass",
    component: _7ab5935c,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _1998f2e8,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _fc9ed1f2,
    name: "samsung"
  }, {
    path: "/sicherheit-und-einbruchschutz",
    component: _6f6483ec,
    name: "sicherheit-und-einbruchschutz"
  }, {
    path: "/smart-home-entdecken",
    component: _c4dad58e,
    name: "smart-home-entdecken"
  }, {
    path: "/smarte-gemuetlichkeit",
    component: _3c3a7f97,
    name: "smarte-gemuetlichkeit"
  }, {
    path: "/soundcore",
    component: _be6c2390,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _bad84bf6,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _440a85ea,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _71156da1,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _04a25d22,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _f35e29e4,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _649b839c,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _fb1d2e5a,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _d2bc3bb2,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _0a4c66da,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/samsung/product-data",
    component: _45a4617c,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _8fa27fb2,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _af870bd0,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _3dbe239a,
    name: "shop-fehler"
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _298f8cd6,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _b5377f84,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _27cea5f8,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _17bf9e32,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _52b163a6,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _f76a52a4,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _1dc1cbe8,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _0dcccaf7,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _2f732385,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _78ceb7cb,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/shop/kundenformular/persoenliche-daten",
    component: _215a159b,
    name: "shop-kundenformular-persoenliche-daten"
  }, {
    path: "/shop/kundenformular/zahlungsart",
    component: _3b57c77c,
    name: "shop-kundenformular-zahlungsart"
  }, {
    path: "/",
    component: _0c9e5648,
    name: "index"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
